import PageBanner from "../PageBanner";
import PageLayout from "../PageLayout";
import bodgan from "../../assets/images/alexandru-bogdan-ghita-mM3gkzh6yn0-unsplash.jpg";
import PageBreadcrumb from "../PageBreadcrumb";
import { ROUTES } from "../../utils/enums";
import StandardPageBlock from "../StandardPageBlock";
import { Tabs, TabsProps } from "antd";
import ProjectOnGoingTabDescription from "../ProjectOnGoingTabDescription";
import ProjectOnGoingTabExecution from "../ProjectOnGoingTabExecution";

const breadcrumbs = [
  { link: ROUTES.PROJECTS_ON_GOING, value: "Projets" },
  { value: "Production de gaz naturel à Ntolo" },
];

const BioDigestorProject = () => {
  const tabItemList: TabsProps["items"] = [
    {
      label: "Description",
      key: "description",
      children: <ProjectOnGoingTabDescription />,
    },
    {
      label: "Execution",
      key: "execution",
      children: <ProjectOnGoingTabExecution />,
      className: "tab-execution",
    },
  ];

  return (
    <PageLayout>
      <>
        <PageBanner
          image={{
            src: bodgan,
            alt: "Production de gaz naturel à Ntolo",
            id: "ntolo",
          }}
          title="Production de gaz naturel à Ntolo"
        />
        <PageBreadcrumb items={breadcrumbs} />
        <StandardPageBlock>
          <Tabs
            defaultActiveKey="description"
            size="large"
            items={tabItemList}
          />
        </StandardPageBlock>
      </>
    </PageLayout>
  );
};

export default BioDigestorProject;
